export const environment = {
  production: false,
  //url: "https://api-crm.policystreet.app",
  url: "https://api-crm-enc.policystreet.app",
  cleverTapId: "TEST-4R4-ZK8-557Z"
};
